import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { CloudTerminalSessionInfo } from '../../services/cloud-terminal-service.js';

@customElement('cp-cloud-terminal-tabs')
export class CpCloudTerminalTabs extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Array }) sessions: CloudTerminalSessionInfo[] = [];
  @property({ type: String }) activeSessionId = '';

  private _onSelect(sessionId: string): void {
    this.dispatchEvent(new CustomEvent('session-select', {
      detail: { sessionId },
      bubbles: true, composed: true,
    }));
  }

  private _onClose(e: Event, sessionId: string): void {
    e.stopPropagation();
    this.dispatchEvent(new CustomEvent('session-close', {
      detail: { sessionId },
      bubbles: true, composed: true,
    }));
  }

  private _getStatusDotClass(status: string): string {
    switch (status) {
      case 'running': return 'cp-cloud-terminal-tabs__dot--running';
      case 'creating': return 'cp-cloud-terminal-tabs__dot--creating';
      case 'error': return 'cp-cloud-terminal-tabs__dot--error';
      default: return 'cp-cloud-terminal-tabs__dot--closed';
    }
  }

  private _getTabLabel(session: CloudTerminalSessionInfo, index: number): string {
    if (session.title) return session.title;
    if (session.type === 'shell') return `Shell ${index + 1}`;
    return session.model?.displayName || `Claude ${index + 1}`;
  }

  render() {
    if (this.sessions.length === 0) return nothing;

    return html`
      <div class="cp-cloud-terminal-tabs">
        <div class="cp-cloud-terminal-tabs__scroll">
          ${this.sessions.map((session, i) => {
            const isActive = session.id === this.activeSessionId;
            const tabClass = `cp-cloud-terminal-tabs__tab${isActive ? ' cp-cloud-terminal-tabs__tab--active' : ''}`;
            return html`
              <button
                class="${tabClass}"
                @click=${() => this._onSelect(session.id)}
                title="${session.id}"
              >
                <span class="cp-cloud-terminal-tabs__dot ${this._getStatusDotClass(session.status)}"></span>
                <span class="cp-cloud-terminal-tabs__label">${this._getTabLabel(session, i)}</span>
                <span
                  class="cp-cloud-terminal-tabs__close"
                  @click=${(e: Event) => this._onClose(e, session.id)}
                  title="Session schliessen"
                >&times;</span>
              </button>
            `;
          })}
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-cloud-terminal-tabs': CpCloudTerminalTabs;
  }
}
